import { render, staticRenderFns } from "./FormFood.vue?vue&type=template&id=1047d3d0"
import script from "./FormFood.vue?vue&type=script&lang=js"
export * from "./FormFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports